export enum COLORS {
    BLACK = "#000000",
    SHADOW_BLACK = "#00000020",
    WHITE = "#ffffff",
    BLUE = "#2699FB",
    GREY = "#DEDEDF",
    GREEN = "#28a745",
    RED = "#d33"
}
